<template>
  <div class="app-wrapper" :class="classObj">
    <div v-if="device === 'mobile' && sidebar.opened" class="drawer-bg" @click="handleClickOutside"></div>
    <div class="sidebar-container">
      <el-row class="my-5" type="flex" justify="center" align="center" style="width: 80%; height: auto; margin:auto">
        <el-image v-if="sidebar.opened" style="width: 160; height: auto" :src="require('@/assets/LandingPage/logo.png')"
          fit="scale-down"></el-image>
      </el-row>
      <el-row class="sidebar-container__navigations pa-5">
        <span v-if="sidebar.opened" class="pl-1"> NAVIGATIONS </span>
      </el-row>
      <sidebar></sidebar>
      <div class="moveBottom" @click="logout"><i class="el-icon-switch-button"></i>
        <span v-if="sidebar.opened" class="logout">Logout</span>
      </div>
    </div>
    <div class="main-container">
      <navbar></navbar>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import uniLogos from '@/assets/js/logoMapping.js'
import EventBus from '@/event/event-bus'


export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    email() {
      return this.$store.getters.email
    },
    role() {
      return this.$store.getters.role
      // return 'u45m'
    },
    balance() {
      return this.$store.getters.balance
    },
    uniLogo() {
      return this.hardcodeUniLogo[this.role]
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('CloseSideBar', { withoutAnimation: false })
    },
    link() {
      window.open('https://nem.io/')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        EventBus.$emit('closeSocket')
        location.reload()
      })
    }
  },
  data() {
    return {
      APP_VERSION: __VERSION__,
      APP_HASH: __COMMITHASH__,
      APP_BRANCH: __BRANCH__,
      logo: uniLogos.dagangNet,
      hardcodeUniLogo: uniLogos
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";

.sidebar-container {
  background-color: #fff8f8;

  .sidebar-container__navigations {
    height: 53px;
    font-size: 12px;
    color: #abafb3;
  }
}

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}

.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.logo {
  width: 160px;
  object-fit: contain;
}

h1 {
  color: #000;
  font-size: 21px;
  font-weight: 900;
  text-align: center;
}

h2 {
  color: #000;
  font-size: 12px;
  font-weight: 500;
  text-align: left;
}

.logout {
  width: 49px;
  height: 16px;
  margin: 1px 0 0px 7px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 3.38;
  letter-spacing: normal;
  text-align: left;
  color: #6a707e;
}

.logout:hover {
  cursor: pointer;
}

.el-icon-switch-button {
  color: #6a707e;
  cursor: pointer;
}

.moveBottom {
  position: absolute;
  padding-left: 20%;
  top: 95%;
  -webkit-transform: translateY(-100%);
  transform: translateY(-100%);
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue